import React from "react";

export default function ProductPricing({
    product,
    setProduct
}) {

    const update = (field, value) => {

        setProduct(prev => ({
            ...prev,
            [field]: value
        }));

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0
                    }}
                >
                    Pricing
                </h2>

                <p
                    style={{
                        color: "#666",
                        marginTop: 8
                    }}
                >
                    Set the selling price, comparison price,
                    cost and currency for this product.
                </p>

            </div>

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb",
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fit,minmax(220px,1fr))",
                    gap: 20
                }}
            >

                {/* Price */}

                <div>

                    <label>Price</label>

                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={product.price ?? ""}
                        onChange={e =>
                            update(
                                "price",
                                e.target.value
                            )
                        }
                        placeholder="0.00"
                        style={inputStyle}
                    />

                </div>

                {/* Compare Price */}

                <div>

                    <label>Compare-at Price</label>

                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={product.comparePrice ?? ""}
                        onChange={e =>
                            update(
                                "comparePrice",
                                e.target.value
                            )
                        }
                        placeholder="0.00"
                        style={inputStyle}
                    />

                </div>

                {/* Cost */}

                <div>

                    <label>Cost Price</label>

                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={product.costPrice ?? ""}
                        onChange={e =>
                            update(
                                "costPrice",
                                e.target.value
                            )
                        }
                        placeholder="0.00"
                        style={inputStyle}
                    />

                </div>

                {/* Currency */}

                <div>

                    <label>Currency</label>

                    <select
                        value={product.currency || "INR"}
                        onChange={e =>
                            update(
                                "currency",
                                e.target.value
                            )
                        }
                        style={inputStyle}
                    >

                        <option value="INR">
                            INR � Indian Rupee
                        </option>

                        <option value="USD">
                            USD � US Dollar
                        </option>

                        <option value="EUR">
                            EUR � Euro
                        </option>

                        <option value="GBP">
                            GBP � British Pound
                        </option>

                        <option value="AED">
                            AED � UAE Dirham
                        </option>

                        <option value="AUD">
                            AUD � Australian Dollar
                        </option>

                        <option value="CAD">
                            CAD � Canadian Dollar
                        </option>

                    </select>

                </div>

            </div>

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb"
                }}
            >

                <h3
                    style={{
                        marginTop: 0
                    }}
                >
                    Pricing Preview
                </h3>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 15,
                        flexWrap: "wrap"
                    }}
                >

                    <strong
                        style={{
                            fontSize: 28
                        }}
                    >
                        {product.currency || "INR"}{" "}
                        {product.price || "0.00"}
                    </strong>

                    {product.comparePrice && (

                        <span
                            style={{
                                color: "#888",
                                textDecoration:
                                    "line-through",
                                fontSize: 18
                            }}
                        >
                            {product.currency || "INR"}{" "}
                            {product.comparePrice}
                        </span>

                    )}

                </div>

            </div>

        </div>

    );

}

const inputStyle = {

    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 15,
    outline: "none"

};